import { Component, inject, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { AuthService } from './core/services/auth.service';
import type { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MenubarModule, ButtonModule, AvatarModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  readonly authService = inject(AuthService);

  readonly menuItems = computed<MenuItem[]>(() => {
    const items: MenuItem[] = [
      { label: 'Dashboard', icon: 'pi pi-home', routerLink: '/dashboard' },
      { label: 'Neue URL', icon: 'pi pi-plus', routerLink: '/url/new' },
      { label: 'Debug', icon: 'pi pi-code', routerLink: '/debug' },
    ];

    if (this.authService.isAdmin()) {
      items.push({
        label: 'Admin',
        icon: 'pi pi-cog',
        items: [
          { label: 'Invite Codes', icon: 'pi pi-key', routerLink: '/admin/invite-codes' },
          { label: 'Telegram Users', icon: 'pi pi-users', routerLink: '/admin/telegram-users' },
          { label: 'Telegram Bots', icon: 'pi pi-android', routerLink: '/admin/telegram-bots' },
          { label: 'Codes', icon: 'pi pi-hashtag', routerLink: '/admin/codes' },
          { label: 'Bot Tokens', icon: 'pi pi-shield', routerLink: '/admin/bot-tokens' },
          { label: 'Fragebögen', icon: 'pi pi-list-check', routerLink: '/admin/questionnaires' },
        ],
      });
    }

    return items;
  });
}
